import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import { GoodsCell } from 'pubBiz/CommonCell';
import { ImgWrap } from 'pubBiz';
import styles from './index.modules.less';
import PropTypes from 'prop-types';

const defaultProps = {
  containerStyle: {},
  data: {
    itemList: []
  },
  productParams: {}
};

// 商品列表成员结构
const itemPropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imgUrl: PropTypes.string
});

const propTypes = {
  containerStyle: PropTypes.object, // 容器样式
  productParams: PropTypes.object, // 商品参数
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 组件宽度
  data: PropTypes.shape({
    floorName: PropTypes.string, // 楼层名称
    imgUrl: PropTypes.string, // 楼层图片
    itemList: PropTypes.arrayOf(itemPropTypes) // 商品列表
  }) // 数据源
};

const GoodsFloorCell = memo((props) => {
  const {
    width, // Any 宽度
    productParams, // Object 商品参数
    data, // Object 数据源
    containerStyle // 容器样式
  } = props;

  // 渲染楼层名称/图片
  const renderHeader = () => {
    const { imgUrl, floorName } = data;
    // 没有标题图片，就不展示
    if (!imgUrl || imgUrl == '') return null;

    return (
      <Flex
        align="center"
        justify="center"
        className={styles.headerContainer}
        style={{ marginBottom: containerStyle.marginTop }}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={width} h={'2.5rem'} />
        <div className={styles.floorName}>
          <span>{floorName}</span>
        </div>
      </Flex>
    );
  };

  // 渲染商品列表
  const renderList = () => {
    const { itemList } = data;

    if (!itemList || itemList.length == 0) {
      return null;
    }

    return (
      <GoodsCell
        width={width}
        data={{
          itemList: itemList.map((item) => ({
            itemInfo: {
              ...item,
              imgUrl: item.imgUrl,
              name: item.name,
              price: item.price,
              type: item.type,
              maxPrice: item.maxPrice
            }
          }))
        }}
        productParams={productParams}
        vertical
        verticalConfig={{
          size: '2.26rem',
          count: 3
        }}
      />
    );
  };

  return (
    <Flex direction="column" style={containerStyle}>
      {renderHeader()}
      {renderList()}
    </Flex>
  );
});

GoodsFloorCell.propTypes = propTypes;

GoodsFloorCell.defaultProps = defaultProps;

export default GoodsFloorCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/GoodsFloorCell/index.js